export function extractList<T>(response: any): T[] {
  if (!response) return [];
  if (Array.isArray(response)) return response as T[];
  if (response.data) {
    const body = response.data;
    if (Array.isArray(body)) return body as T[];
    if (body.results && Array.isArray(body.results)) return body.results as T[];
    return [];
  }
  if (response.results && Array.isArray(response.results)) return response.results as T[];
  return [];
}
